import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import inductionModules, { INDUCTION_VERSION, INDUCTION_PROGRESS_KEY } from '../../data/inductionModules';

const readVisited = () => {
  try {
    const raw = localStorage.getItem(INDUCTION_PROGRESS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};

const InductionHome = () => {
  const [visited, setVisited] = useState([]);

  useEffect(() => {
    setVisited(readVisited());
  }, []);

  const hasProgress = visited.length > 0;
  const startModuleId = hasProgress ? Math.max(...visited) : 1;

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      {/* DRAFT — landing page copy not yet approved by the RBYC Aquatic Subcommittee */}
      <h1>Brighton Icebergers Safety Induction</h1>

      <p>Every new Iceberger completes this safety induction before their first swim with us.</p>

      <p>
        It takes about 30 minutes. There are eight short modules and a 20-question
        assessment at the end. You need 16 correct to pass, and you can retake it as
        many times as you need.
      </p>

      <p>
        You don't need an account or a password. Work through it in one sitting, or
        come back to it later. This device will remember where you got to.
      </p>

      <ol style={{ listStyle: 'none', padding: 0 }}>
        {inductionModules.map((module) => {
          const isVisited = visited.includes(module.id);
          return (
            <li key={module.id} style={{ marginBottom: '10px' }}>
              <Link to={`/induction/module/${module.id}`}>
                {isVisited && <span aria-hidden="true">✓ </span>}
                Module {module.id}: {module.title}
              </Link>
              {' '}
              <span style={{ color: '#555' }}>({module.durationMinutes} min)</span>
              {isVisited && <span className="visually-hidden">, visited</span>}
            </li>
          );
        })}
      </ol>

      <p>
        <br></br>
        <Link to={`/induction/module/${startModuleId}`} className="external-link-btn">
          {hasProgress ? 'Continue the induction' : 'Start the induction'}
        </Link>
      </p>

      <p style={{ color: '#555', fontSize: '14px', marginTop: '40px' }}>
        Brighton Icebergers Safety Induction Program &middot; {INDUCTION_VERSION}
        <br />
        Prepared by the RBYC Aquatic Subcommittee
      </p>
    </div>
  );
};

export default InductionHome;
